import { action, computed, makeAutoObservable } from "mobx";
import { ApplicationSdk } from "..";

class TmpCategory {
    private sdk: ApplicationSdk;
    public loading: boolean = false;
    public categoryStorage: Array<any> = [];
    public lastUpdateCache: string | null;

    constructor(sdk: ApplicationSdk) {
        this.sdk = sdk;
        this.lastUpdateCache = null;
        makeAutoObservable(this, {
            all: computed,
            update: action
        })
    }

    get all() {
        return this.categoryStorage;
    }

    public needRefresh(newHash: string) {
        return this.lastUpdateCache === null || this.lastUpdateCache !== newHash;
    }

    public update(list: [], newHash: string): Array<any> {
        this.categoryStorage = list;
        this.lastUpdateCache = newHash;
        return list;
    }
}

export default TmpCategory;